var map = {
	"./007-microphone-1.png": 816,
	"./010-home.png": 817,
	"./013-document-1.png": 818,
	"./014-document.png": 819,
	"./015-color-palette.png": 820,
	"./017-video-camera.png": 821,
	"./024-like.svg": 822,
	"./1.svg": 823,
	"./155-credit-card.svg": 824,
	"./2.svg": 825,
	"./3.svg": 826,
	"./4.svg": 827,
	"./New Customer.svg": 807,
	"./NotOpen.svg": 828,
	"./Opened.svg": 829,
	"./Profit.svg": 808,
	"./SalesRevenue.svg": 809,
	"./Sent.svg": 830,
	"./Slack.svg": 831,
	"./address.svg": 832,
	"./adobe.svg": 833,
	"./arrow-left.svg": 341,
	"./arrow-right.svg": 342,
	"./book.svg": 834,
	"./camera.svg": 835,
	"./chat.svg": 836,
	"./clipboard.svg": 837,
	"./cloud.svg": 838,
	"./columns.svg": 810,
	"./documentation.svg": 839,
	"./file.svg": 840,
	"./flat.svg": 841,
	"./headphone.svg": 842,
	"./iconfinder_trello_2317760.svg": 843,
	"./idea.svg": 844,
	"./image.png": 845,
	"./image.svg": 846,
	"./label.png": 880,
	"./layers.svg": 847,
	"./left.svg": 848,
	"./logo2.svg": 849,
	"./logo3.svg": 850,
	"./logo4.svg": 851,
	"./logo5.svg": 852,
	"./logo6.svg": 853,
	"./logoIn.svg": 854,
	"./paint.svg": 855,
	"./protection.svg": 856,
	"./quote.png": 881,
	"./repeat.svg": 811,
	"./right.svg": 857,
	"./strategy.svg": 858,
	"./theme.svg": 859,
	"./user.svg": 860,
	"./water-fall.svg": 861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 879;